import Icon from '../components/Icon.vue'

Icon.register({"dropbox":{"width":1792,"height":1792,"paths":[{"d":"M402 707l494 305-342 285-490-319zM1388 1262v108l-490 293v1l-1-1-1 1v-1l-489-293v-108l147 96 342-284v-2l1 1 1-1v2l343 284zM554 118l342 285-494 304-338-270zM1390 707l338 271-489 319-343-285zM1239 118l489 319-338 270-494-304z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/dropbox.js
// module id = 505
// module chunks = 0